
<template>
  <div>
    <a-range-picker :disabled-date="disabledDate" v-model="priceRangeDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @calendarChange="calendarPriceRangeChange" @change="changePriceRangeDate" />
  </div>
</template>

<script>
// 传入 limit 获取 跨度 上限的时间选择
import { reactive, toRefs } from "@vue/reactivity";
import { inject } from '@vue/runtime-core';
export default {
  props: {
    limit: {
      type: Number,
      default: () => {
        return 7;
      },
    },
  },
  name:"spanLimitRangeTime",
  setup(props,{emit}) {
    const state = reactive({
      priceRangeDate: [],
      selectPriceDate: "",
      offsetDays: 86400000 , //最多选择7天
    });
    const moment=inject('momentTime')
    //选择完时间 清空限制
    const changePriceRangeDate = (date) => {
      state.selectPriceDate = "";
      emit('change',date)
    };
    //选择开始时间/结束时间
    const calendarPriceRangeChange = (date) => {
      state.selectPriceDate = date[0];
    
    };
    const disabledDate=(current)=>{
        var offsetDays=state.offsetDays * props.limit
         if(state.selectPriceDate){
                let selectV = moment(state.selectPriceDate, 'YYYY-MM-DD').valueOf()
                return moment(current, 'YYYY-MM-DD').valueOf() > selectV+offsetDays ||
                        moment(current, 'YYYY-MM-DD').valueOf() < selectV-offsetDays 
         }else{
             return false
         }
    }
    return {
      ...toRefs(state),
      changePriceRangeDate,
      calendarPriceRangeChange,
      disabledDate
    };
  },
};
</script>